import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mb-3"
}
const _hoisted_2 = { class: "col-12 p-5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = {
  key: 0,
  class: "col-6 px-5 py-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "Set password", -1)
const _hoisted_11 = {
  key: 0,
  class: "alert alert-danger mb-3"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-start mt-3" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn-gradient btn-modal rounded-pill"
  }, "Save password")
], -1)
const _hoisted_13 = {
  key: 1,
  class: "col-12 px-5 py-4"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h5", null, "Password saved", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, "Your password has been saved, please keep your password secure.", -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center justify-content-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fa fa-spinner fa-spin fa-fw fa-2x" })
], -1)
const _hoisted_19 = [
  _hoisted_18
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    title: _ctx.ready ? 'Register' : 'Please wait',
    onConfirm: _cache[5] || (_cache[5] = ($event: any) => (_ctx.purchase())),
    "cancel-button": false,
    "min-width": "800px",
    "max-width": "800px"
  }, {
    default: _withCtx(() => [
      (_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("p", null, " Hi " + _toDisplayString(_ctx.name) + ", ", 1),
              (!_ctx.signupCompleted)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_ctx.newUser && !_ctx.passwordSaved)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_3, " The Appstore account for " + _toDisplayString(_ctx.businessUnitName) + " account is being created. When the account is created you will receive an email with instructions to login. In the meantime, please set a password for your account. So you can login later. ", 1))
                      : (_ctx.newUser)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_4, " The Appstore account for " + _toDisplayString(_ctx.businessUnitName) + " account is being created. When the account is created you will receive an email with instructions to login. You can then login with your saved password. ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_5, " The Appstore account for " + _toDisplayString(_ctx.businessUnitName) + " account is being created. When the account is created you will receive an email with instructions to login. Since you already have an account, you can then login with your existing credentials. ", 1)),
                    (!_ctx.newUser || _ctx.passwordSaved)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "btn-gradient btn-modal rounded-pill",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (this.$router.push({ name: 'login' })))
                        }, "Login"))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_ctx.newUser && !_ctx.passwordSaved)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_6, " The Appstore account for " + _toDisplayString(_ctx.businessUnitName) + " account is created. Please set a password for your account. So you can login. ", 1))
                      : (_ctx.newUser)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_7, " The Appstore account for " + _toDisplayString(_ctx.businessUnitName) + " account is created. You can login with your saved password. ", 1))
                        : (_openBlock(), _createElementBlock("p", _hoisted_8, " The Appstore account for " + _toDisplayString(_ctx.businessUnitName) + " account is created. Since you already have an account, you can login with your existing credentials. ", 1)),
                    (!_ctx.newUser || _ctx.passwordSaved)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 3,
                          class: "btn-gradient btn-modal rounded-pill",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (this.$router.push({ name: 'login' })))
                        }, "Login"))
                      : _createCommentVNode("", true)
                  ], 64))
            ]),
            (_ctx.passwordToken && !_ctx.passwordSaved && _ctx.newUser)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  (_ctx.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_ctx.error), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("form", {
                    class: "mt-3",
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.savePassword()), ["stop","prevent"]))
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control mb-2",
                      placeholder: "Password",
                      "aria-label": "Password",
                      "aria-describedby": "basic-addon1",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.password) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.password]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "password",
                      class: "form-control",
                      placeholder: "Confirm Password",
                      "aria-label": "Confirm Password",
                      "aria-describedby": "basic-addon1",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.confirmPassword) = $event)),
                      required: ""
                    }, null, 512), [
                      [_vModelText, _ctx.confirmPassword]
                    ]),
                    _hoisted_12
                  ], 32)
                ]))
              : (_ctx.passwordSaved)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
                : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
    ]),
    _: 1
  }, 8, ["title"]))
}